import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faBook, faGlasses } from '@fortawesome/free-solid-svg-icons'
import Search from './Search'
import {Indice, getIndice} from './Libro/Index'

const Tooltip = props =>
    <div className="tooltip">
        {props.children}
        <div className="tooltip__window">
            {props.title}
        </div>
    </div>

Tooltip.propTypes = {
    title: PropTypes.string,
}

Tooltip.defaultProps = {
    title: '',
}
const Actions = props =>
    <div className="actions">{ props.children }</div>

const ActionsItem = props =>
    <div onClick={() => props.onClick()} className="actions__item">
        <FontAwesomeIcon className="actions__icon" icon={props.icon} />
        <div className="actions__description">{ props.children }</div>
    </div>

ActionsItem.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.any,
    onClick: PropTypes.func,
}

ActionsItem.defaultProps = {
    className: '',
}

const ActionsItemRange = props =>
    <div className="actions__item actions__item--range">
        <FontAwesomeIcon className="actions__icon" icon={props.icon} />
        <input onChange={props.range} className="actions__range" type="range" min="0.75" max="1.75" step="0.05" value={props.scale} />
    </div>

ActionsItemRange.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.any,
    range: PropTypes.func
}

ActionsItemRange.defaultProps = {
    className: '',
}

const Logo = props =>
    <div className="logo">
        <img className="logo__image" src={process.env.PUBLIC_URL+"/logo-maggioli-editore.svg"} alt="Maggioli s.p.a."></img>
    </div>

class MenuLeft extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            search: false,
            info: false,
            scale: this.props.scale,
            indiceStatus: false,
            fromPage: this.props.dataPage.fromPage,
            toPage: this.props.dataPage.toPage,
            type: this.props.type
        }
    }

    __search = () => {
        let status = true;
        if( this.state.search === true )
        {
            status = false
        }
        this.setState({ search: status, info: false })
    }

    __info = () => {
        let status = true;
        if( this.state.info === true )
        {
            status = false
        }
        this.setState({info: status, search: false})
    }

    __handleRange = (event) => {
        let scale = event.target.value
        let container = document.getElementById("page-container")
        this.setState({
            scale: scale
        }, () => {
            const book = document.getElementsByClassName("book")[0]
            book.style.transform = `scale(${scale})`
            book.style.transformOrigin = `50% ${container.scrollTop}px`
            this.props.resetScale(scale)
        })
    }

    __handleRangeFromParent = (scale) => {
        let container = document.getElementById("page-container")
        this.setState({
            scale: scale
        }, () => {
            const book = document.getElementsByClassName("book")[0]
            book.style.transform = `scale(${scale})`
            book.style.transformOrigin = `50% ${container.scrollTop}px`
            this.props.resetScale(scale)
        })
    }

    __checkIndice = async () => {
        const response = await getIndice(this.props.bookId, this.props.type)
        const data = await response.json()
        if( data )
        {
            this.setState({
                indiceStatus: true
            })
        }
    }

    __placeholder = () => {
        return this.props.type === 'libro' ? `Cerca nel ${this.props.type}` : `Cerca nel ${this.props.type}`
    }
    
    componentDidUpdate() {
        if(this.props.scale === 1 && this.state.scale !== 1) // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id)
        {
            this.setState({
                scale: 1
            }, () => {
                const book = document.getElementsByClassName("book")[0]
                let container = document.getElementById("page-container")
                book.style.transform = `scale(1)`
                book.style.transformOrigin = `50% ${container.scrollTop}px`
            })
        }
    }

    componentDidMount = () => {
        
        this.__handleRangeFromParent(this.state.scale)
        this.__checkIndice()
    }

    render = () => {
        return (
            <div className={`menu menu--left ${this.state.search || this.state.info ? 'menu--active' : ''}`}>
                <Logo />
                <Actions>
                    <Tooltip title="Utilizza la barra per regolare la dimensione della pagina">
                        <ActionsItemRange range={(e) => this.__handleRange(e)} scale={this.state.scale} icon={faGlasses} />
                    </Tooltip>
                    {this.state.search
                        ? <Search display={() => this.__search()} bookId={this.props.bookId} type={this.props.type} icon={faSearch} placeholder={this.__placeholder()} dataPage={{
                            fromPage: this.state.fromPage,
                            toPage: this.state.toPage
                        }} />
                        : <Tooltip title="Inserisci le parole chiave da ricercare nelle pagine del volume">
                            <ActionsItem onClick={this.__search} icon={faSearch}>{this.__placeholder()}</ActionsItem>
                        </Tooltip>
                    }
                    {
                        (!this.state.fromPage || !this.state.toPage) ? // mostra indice se in false una variabile o l'altra di from to page
                            this.state.info && this.state.indiceStatus
                                ? <Indice display={() => this.__info()} bookId={this.props.bookId} type={this.props.type} icon={faBook} title="Indice" />
                                : <Tooltip title="Clicca sulle voci per visualizzare immediatamente la sezione del volume di tuo interesse">
                                    <ActionsItem onClick={this.__info} icon={faBook}>Indice</ActionsItem>
                                </Tooltip>
                        : null                    
                    }
                </Actions>
            </div>
        )
    }
}

MenuLeft.propTypes = {
    bookId: PropTypes.string,
}

export default  MenuLeft
